import { createSlice, createSelector, createAsyncThunk, isRejectedWithValue } from "@reduxjs/toolkit";
import axios from "axios";
import { OFFERSATFIRSTREQUEST, OFFERSPERREQUEST } from "./config";
import { boardTypes, getHost, hotelSortOptions, normalizeRoomAllocation, populateAlternativeFlightsPost, populateOfferPost, populatePost, roomAllocationIsHeterogeneous, allowsAutoAvailabilityCheck, withoutMapSelection } from "./utils";

const heteroRoomAllocationParam = (raw) => {
  const alloc = normalizeRoomAllocation(raw);
  return alloc && roomAllocationIsHeterogeneous(alloc) ? JSON.stringify(alloc) : undefined;
};
import { format } from "date-fns";
import { setOutbounddate } from "./searchSlice";
import { addClassicOffers, addOffers, clearCards, clearClassicCards } from "./configuartionSlice";

axios.defaults.headers.common["AgencyID"] = window.configData.AGENCYID;
axios.defaults.headers.common["Version"] = import.meta.env.VITE_APP_VERSION;
axios.defaults.headers.common["App"] = window.configData.APP;

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const addValuesToOffer = (offer, state) => {
  return {
    ...offer,
    adults: state.search.adults.value,
    children: state.search.children.value,
    duration: state.search.duration.label,
    stations: state.search.stations,
    travelDate: state.search.travelDate.from,
    destination: { ...state.hotel.selectedHotel },
    displaydestination: [...state.search.selectedDestination],
  };
};

export const getRegionInfo = createAsyncThunk("hotel/getRegionInfo", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/getregioninfo?id=" + payload.id);
    return response.data.ret;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const getCityInfo = createAsyncThunk("hotel/getCityInfo", async (payload, thunkAPI) => {
  try {
    const response = await axios.get(getHost() + "/getcityinfo?id=" + payload.id);
    return response.data.ret;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const searchBestValueOffers = createAsyncThunk("hotel/searchBestValueOffers", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();
  //console.log(JSON.stringify(state.hotel.selectedHotel));

  try {
    let apicall = "touroperatoroffers";
    if (state.search.activeMode == "ACC") {
      apicall = "touroperatoraccommodationoffers";
    }
    let response = await axios.post(getHost() + "/" + apicall, {
      ...populatePost(
        [state.hotel.selectedHotel],
        {
          ...withoutMapSelection(state.search),
          promosession: state.system.sessionId,
          sorting: state.hotel.hotelSort,
          offset: payload.offset,

          amount: 5,
        },
        state.properties.departureStations,
      ),
      minDuration: state.search.duration.value.indexOf("-") > -1 ? state.search.duration.value.split("-")[1] * 1 : state.search.duration.value * 1,
      maxDuration: state.search.duration.value.indexOf("-") > -1 ? state.search.duration.value.split("-")[1] * 1 : state.search.duration.value * 1,
      outboundtime: "06:00-10:00",
      inboundtime: "18:00-22:00",

      //sortOrder: apicall == "packageOffers" ? ["PriceAsc"] : undefined,

      ratingcount: "0",
      recommendationrate: "0",
      category: "",
      mode: state.system.mode,
      couponcode: state.search.couponcode,
      //hotelAttribute: [],
    });

    if (response.data.Offers.OfferCount > 0) {
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return addValuesToOffer(e, state);
      });

      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return !e.OfferServices.Package
          ? {
              ...e,
              OfferServices: {
                Package: { Accommodation: e.OfferServices.Accommodation },
              },
            }
          : e;
      });
      for (let i = 0; i < response.data.Offers.Offer.length; i++) {
        let offer = response.data.Offers.Offer[i];
        if (offer?.OfferServices?.Package?.Accommodation?.Room?.RoomName) {
          try {
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\,/g, ", ");
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\//g, "/ ");
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\-/g, "- ");
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\./g, ". ");
          } catch (e) {}
        }
        if (offer?.OfferServices?.Package?.Accommodation?.BoardType) {
          let bt = boardTypes.find((e) => e.searchKeys.includes(offer?.OfferServices?.Package?.Accommodation?.BoardType));
          if (bt) {
            offer.OfferServices.Package.Accommodation.BoardType = bt.value;
          }
        }
      }
    }

    if (Array.isArray(response.data.Offers.Offer)) {
      if (state.search.durationkind && state.search.durationkind.value === "Stay") {
        let dur = state.search.duration.value;

        if (dur === "0.1") {
          let differenceInTime = new Date(state.search.travelDate.to.split('"').join("")).getTime() - new Date(state.search.travelDate.from.split('"').join("")).getTime();

          dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
          if (state.search.durationkind.value === "Stay") dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
        }
        if ((dur + "").indexOf("-") > -1) {
          let durmin = dur.split("-")[0] * 1;
          let durmax = dur.split("-")[1] * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays >= durmin && e.TravelDateInfo.OvernightStays <= durmax);
        } else {
          dur = dur * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays === dur);
        }
      }

      //response.data.Offers.OfferCount = response.data.Offers.Offer.length;
    }

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const searchPremiumOffers = createAsyncThunk("hotel/searchPremiumOffers", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();
  //console.log(JSON.stringify(state.hotel.selectedHotel));

  try {
    let apicall = "touroperatoroffers";
    if (state.search.activeMode == "ACC") {
      apicall = "touroperatoraccommodationoffers";
    }
    let response = await axios.post(getHost() + "/" + apicall, {
      ...populatePost(
        [state.hotel.selectedHotel],
        {
          ...withoutMapSelection(state.search),
          promosession: state.system.sessionId,
          sorting: state.hotel.hotelSort,
          offset: payload.offset,

          amount: 5,
        },
        state.properties.departureStations,
      ),
      minDuration: state.search.duration.value.indexOf("-") > -1 ? state.search.duration.value.split("-")[1] * 1 : state.search.duration.value * 1,
      maxDuration: state.search.duration.value.indexOf("-") > -1 ? state.search.duration.value.split("-")[1] * 1 : state.search.duration.value * 1,
      outboundtime: "06:00-10:00",
      inboundtime: "18:00-22:00",
      transferincluded: true,
      addablecancellation: true,
      //sortOrder: apicall == "packageOffers" ? ["PriceAsc"] : undefined,

      ratingcount: "0",
      recommendationrate: "0",
      category: "",
      mode: state.system.mode,
      couponcode: state.search.couponcode,
      //hotelAttribute: [],
    });

    if (response.data.Offers.OfferCount > 0) {
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return addValuesToOffer(e, state);
      });

      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return !e.OfferServices.Package
          ? {
              ...e,
              OfferServices: {
                Package: { Accommodation: e.OfferServices.Accommodation },
              },
            }
          : e;
      });
      for (let i = 0; i < response.data.Offers.Offer.length; i++) {
        let offer = response.data.Offers.Offer[i];
        if (offer?.OfferServices?.Package?.Accommodation?.Room?.RoomName) {
          try {
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\,/g, ", ");
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\//g, "/ ");
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\-/g, "- ");
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\./g, ". ");
          } catch (e) {}
        }
        if (offer?.OfferServices?.Package?.Accommodation?.BoardType) {
          let bt = boardTypes.find((e) => e.searchKeys.includes(offer?.OfferServices?.Package?.Accommodation?.BoardType));
          if (bt) {
            offer.OfferServices.Package.Accommodation.BoardType = bt.value;
          }
        }
      }
    }

    if (Array.isArray(response.data.Offers.Offer)) {
      if (state.search.durationkind && state.search.durationkind.value === "Stay") {
        let dur = state.search.duration.value;

        if (dur === "0.1") {
          let differenceInTime = new Date(state.search.travelDate.to.split('"').join("")).getTime() - new Date(state.search.travelDate.from.split('"').join("")).getTime();

          dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
          if (state.search.durationkind.value === "Stay") dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
        }
        if ((dur + "").indexOf("-") > -1) {
          let durmin = dur.split("-")[0] * 1;
          let durmax = dur.split("-")[1] * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays >= durmin && e.TravelDateInfo.OvernightStays <= durmax);
        } else {
          dur = dur * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays === dur);
        }
      }

      //response.data.Offers.OfferCount = response.data.Offers.Offer.length;
    }

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const searchLowestPriceOffers = createAsyncThunk("hotel/searchLowestPriceOffers", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();
  //console.log(JSON.stringify(state.hotel.selectedHotel));

  try {
    let apicall = "touroperatoroffers";
    if (state.search.activeMode == "ACC") {
      apicall = "touroperatoraccommodationoffers";
    }
    let response = await axios.post(getHost() + "/" + apicall, {
      ...populatePost(
        [state.hotel.selectedHotel],
        {
          ...withoutMapSelection(state.search),
          promosession: state.system.sessionId,
          sorting: state.hotel.hotelSort,
          offset: payload.offset,

          amount: 5,
        },
        state.properties.departureStations,
      ),
      //sortOrder: apicall == "packageOffers" ? ["PriceAsc"] : undefined,

      ratingcount: "0",
      recommendationrate: "0",
      category: "",
      mode: state.system.mode,
      couponcode: state.search.couponcode,
      //hotelAttribute: [],
    });

    if (response.data.Offers.OfferCount > 0) {
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return addValuesToOffer(e, state);
      });

      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return !e.OfferServices.Package
          ? {
              ...e,
              OfferServices: {
                Package: { Accommodation: e.OfferServices.Accommodation },
              },
            }
          : e;
      });
      for (let i = 0; i < response.data.Offers.Offer.length; i++) {
        let offer = response.data.Offers.Offer[i];
        if (offer?.OfferServices?.Package?.Accommodation?.Room?.RoomName) {
          try {
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\,/g, ", ");
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\//g, "/ ");
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\-/g, "- ");
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\./g, ". ");
          } catch (e) {}
        }
        if (offer?.OfferServices?.Package?.Accommodation?.BoardType) {
          let bt = boardTypes.find((e) => e.searchKeys.includes(offer?.OfferServices?.Package?.Accommodation?.BoardType));
          if (bt) {
            offer.OfferServices.Package.Accommodation.BoardType = bt.value;
          }
        }
      }
    }

    if (Array.isArray(response.data.Offers.Offer)) {
      if (state.search.durationkind && state.search.durationkind.value === "Stay") {
        let dur = state.search.duration.value;

        if (dur === "0.1") {
          let differenceInTime = new Date(state.search.travelDate.to.split('"').join("")).getTime() - new Date(state.search.travelDate.from.split('"').join("")).getTime();

          dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
          if (state.search.durationkind.value === "Stay") dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
        }
        if ((dur + "").indexOf("-") > -1) {
          let durmin = dur.split("-")[0] * 1;
          let durmax = dur.split("-")[1] * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays >= durmin && e.TravelDateInfo.OvernightStays <= durmax);
        } else {
          dur = dur * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays === dur);
        }
      }

      //response.data.Offers.OfferCount = response.data.Offers.Offer.length;
    }

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const searchHotelOffers = createAsyncThunk("hotel/searchHotelOffers", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();
  //console.log(JSON.stringify(state.hotel.selectedHotel));

  let rownumber = 0;
  let topseller = false;
  let actionid = "";

  if (Array.isArray(state.offers.queryorder)) {
    for (let i = 0; i < state.offers.queryorder.length; i++) {
      //console.log(state.offers.queryorder[i]);
      if (state.hotel.selectedHotel?.HotelCodes?.HotelGiataID && state.hotel.selectedHotel?.HotelCodes?.HotelGiataID === state.offers.queryorder[i].giataid) {
        rownumber = state.offers.queryorder[i].rownumber;
        topseller = state.offers.queryorder[i].topseller;
        actionid = state.offers.queryorder[i].actionid;
        break;
      }
    }
  }

  try {
    if (payload.offset == 0) {
      thunkAPI.dispatch(clearCards());
      thunkAPI.dispatch(clearClassicCards());
      axios.post(getHost() + "/sendQuery", {
        ...populatePost(
          state.search.selectedDestination,
          {
            ...state.search,

            promosession: state.system.sessionId,
            offset: payload.offset,
            amount: payload.offset > 0 ? OFFERSPERREQUEST : OFFERSATFIRSTREQUEST,
          },
          state.properties.departureStations,
        ),
        searchOptions: { ...state.search },
        hotel: state.hotel.selectedHotel,
        offerId: state.offers.selectedOfferId,
        sortOrder: state.search.sorting.sorting,
        mode: state.system.mode,
        couponcode: state.search.couponcode,
        // Nachladen in der Detailansicht — keine neue Auswahl des Gastes.
        // Ohne diese Markierung zaehlt dieselbe Hotelansicht mehrfach.
        click_origin: "reload",
        click_position: null,
        //travellers: state.search.travellers,
      });
    }

    let apicall = "touroperatoroffers";

    if (state.search.activeMode == "ACC") {
      apicall = "touroperatoraccommodationoffers";
    }
    //let apicall = "packageOffers";
    if (payload.cross) {
      apicall = "packageOffers";
      if (state.search.activeMode == "ACC") {
        apicall = "accommodationOffers";
      }
    }

    let response = await axios.post(getHost() + "/" + apicall, {
      ...populatePost(
        [state.hotel.selectedHotel],
        {
          ...withoutMapSelection(state.search),
          promosession: state.system.sessionId,
          sorting: state.hotel.hotelSort,
          offset: payload.offset,

          // touroperatoroffers/touroperatoraccommodationoffers liefern ein Angebot pro
          // Touroperator (nicht seitenweise paginiert) - amount muss deshalb immer weit
          // ueber der real existierenden Touroperator-Anzahl liegen (~150), sonst kappt
          // bestPackageOfferForTourOperator (amadeuspackage.js) NumberOfResults und
          // laesst Touroperatoren jenseits davon stillschweigend weg. 500 statt 200 als
          // zusaetzliche Sicherheitsmarge - damit gibt es fuer diese Liste nie eine
          // weitere Seite, ein Nachlade-Mechanismus im Client ist ueberfluessig.
          amount: 500,
        },
        state.properties.departureStations,
      ),
      //sortOrder: apicall == "packageOffers" ? ["PriceAsc"] : undefined,
      rownumber: rownumber,
      topseller: topseller,
      actionid: actionid,
      ratingcount: "0",
      recommendationrate: "0",
      category: "",
      mode: state.system.mode,
      couponcode: state.search.couponcode,
      //hotelAttribute: [],
    });

    if (payload.offset == 0) {
      if (response.data.Offers.OfferCount > 0) {
        thunkAPI.dispatch(
          searchDepartureDates({
            offerdate: response.data.Offers.Offer[0].TravelDateInfo.DepartureDate
              ? response.data.Offers.Offer[0].TravelDateInfo.DepartureDate
              : response.data.Offers.Offer[0].TravelDateInfo.CheckInDate,
          }),
        );
      }
    }

    if (response.data.Offers.OfferCount > 0) {
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return addValuesToOffer(e, state);
      });

      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return !e.OfferServices.Package
          ? {
              ...e,
              OfferServices: {
                Package: { Accommodation: e.OfferServices.Accommodation },
              },
            }
          : e;
      });
      for (let i = 0; i < response.data.Offers.Offer.length; i++) {
        let offer = response.data.Offers.Offer[i];
        if (offer?.OfferServices?.Package?.Accommodation?.Room?.RoomName) {
          try {
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\,/g, ", ");
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\//g, "/ ");
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\-/g, "- ");
            offer.OfferServices.Package.Accommodation.Room.RoomName = offer.OfferServices.Package.Accommodation.Room.RoomName.replace(/\./g, ". ");
          } catch (e) {}
        }
        if (offer?.OfferServices?.Package?.Accommodation?.BoardType) {
          let bt = boardTypes.find((e) => e.searchKeys.includes(offer?.OfferServices?.Package?.Accommodation?.BoardType));
          if (bt) {
            offer.OfferServices.Package.Accommodation.BoardType = bt.value;
          }
        }
      }
    }

    if (Array.isArray(response.data.Offers.Offer)) {
      if (state.search.durationkind && state.search.durationkind.value === "Stay") {
        let dur = state.search.duration.value;

        if (dur === "0.1") {
          let differenceInTime = new Date(state.search.travelDate.to.split('"').join("")).getTime() - new Date(state.search.travelDate.from.split('"').join("")).getTime();

          dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
          if (state.search.durationkind.value === "Stay") dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
        }
        if ((dur + "").indexOf("-") > -1) {
          let durmin = dur.split("-")[0] * 1;
          let durmax = dur.split("-")[1] * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays >= durmin && e.TravelDateInfo.OvernightStays <= durmax);
        } else {
          dur = dur * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays === dur);
        }
      }

      //response.data.Offers.OfferCount = response.data.Offers.Offer.length;
    }

    thunkAPI.dispatch(
      addOffers({
        offers: Array.isArray(response.data.Offers.Offer) ? response.data.Offers.Offer : [],
        payload: { ...payload, thunk: "searchHotelOffers" },
        meta: (({ Offer, ...rest }) => rest)(response.data.Offers),
      }),
    );
    thunkAPI.dispatch(
      addClassicOffers({
        offers: Array.isArray(response.data.Offers.Offer) ? response.data.Offers.Offer : [],
        payload: { ...payload, thunk: "searchHotelOffers" },
        meta: (({ Offer, ...rest }) => rest)(response.data.Offers),
      }),
    );

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const searchDepartureDates = createAsyncThunk("hotel/searchDepartureDates", async (payload, thunkAPI) => {
  try {
    const state = thunkAPI.getState();

    let duration = { ...state.search.duration };

    let dur = 7;

    if (!isNaN(duration.value)) dur = duration.value * 1;
    else {
      dur = duration.value.split("-")[1] * 1;
    }

    let msFrom = new Date(payload.offerdate ? payload.offerdate : state.search.priceChartDates?.outbound ? state.search.priceChartDates?.outbound : state.search.outbounddate).getTime() - 6 * 86400000;
    let from = new Date(msFrom);
    let msUntil =
      new Date(payload.offerdate ? payload.offerdate : state.search.priceChartDates?.outbound ? state.search.priceChartDates?.outbound : state.search.outbounddate).getTime() + (dur + 7) * 86400000;
    let until = new Date(msUntil);

    if (from.getTime() < new Date().getTime()) {
      from = new Date().setDate(new Date().getDate() + 1);
      until = new Date().setDate(new Date().getDate() + dur + 7);
    }

    let travelDate = {
      from: format(from, "yyyy-MM-dd"),
      until: format(until, "yyyy-MM-dd"),
    };

    if (payload?.from) {
      travelDate = {
        from: payload.from,
        until: payload.until,
      };
    }

    //console.log(travelDate);
    thunkAPI.dispatch(setDoCalendarCheck(true));

    let url = "/bestPackageOfferForDepartureDate";
    if (state.search.activeMode == "ACC") url = "/bestAccommodationOfferForCheckInDate";

    const response = await axios.post(getHost() + url, {
      ...populatePost(
        [state.hotel.selectedHotel],
        {
          ...{
            ...withoutMapSelection(state.search),
            travelDate: travelDate,
            duration: duration,
          },

          promosession: state.system.sessionId,
          sorting: state.hotel.hotelSort,
        },
        state.properties.departureStations,
      ),
      outboundrange: [travelDate.from, travelDate.until],
      outbounddate: null,
      minDate: travelDate.from,
      maxDate: travelDate.until,
      mode: state.system.mode,
      couponcode: state.search.couponcode,
    });

    response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
      return !e.OfferServices.Package
        ? {
            ...e,
            OfferServices: {
              Package: { Accommodation: e.OfferServices.Accommodation },
            },
          }
        : e;
    });

    if (response.data.Offers.OfferCount > 0) {
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return addValuesToOffer(e, state);
      });

      (async () => {
        const promises = response.data.Offers.Offer.map(async (offer) => {
          await sleep(10);

          const accommodation = offer.OfferServices?.Package?.Accommodation;

          let hotel = response.data.HotelDictionary?.Hotel?.find((e) => e.HotelID == accommodation?.HotelRef?.HotelID);

          await thunkAPI.dispatch(
            availabilityAndPriceCheckCalendar({
              OfferID: offer.OfferID,
              HotelGiataID: hotel?.HotelCodes?.HotelGiataID,
            }),
          );
        });

        await Promise.all(promises);

        thunkAPI.dispatch(setDoCalendarCheck(false));
      })();
    } else {
      thunkAPI.dispatch(setDoCalendarCheck(false));
    }

    //console.log(response.data);
    return response.data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const searchDurationVariants = createAsyncThunk("hotel/searchDurationVariants", async (payload, thunkAPI) => {
  try {
    const state = thunkAPI.getState();

    const response = await axios.post(getHost() + "/durationVariants", {
      ...populatePost([state.hotel.selectedHotel], { ...withoutMapSelection(state.search), promosession: state.system.sessionId }, state.properties.departureStations),
      activeMode: state.search.activeMode,
    });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

// Reine lokale Berechnung im ibe_server (kein Peakwork/Amadeus-Call) - liefert die
// tatsaechliche Naechtezahl pro Dauer-Kachel, damit die Leiste sofort/parallel zur
// langsameren searchDurationVariants-Preisabfrage korrekt beschriften kann.
export const searchDurationInfo = createAsyncThunk("hotel/searchDurationInfo", async (payload, thunkAPI) => {
  try {
    const state = thunkAPI.getState();

    const response = await axios.post(getHost() + "/durationInfo", {
      duration: state.search.duration?.value,
      weekPreset: state.search.duration?.weekPreset || null,
      activeMode: state.search.activeMode,
    });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const searchBetterOffers = createAsyncThunk("hotel/searchBetterOffers", async (payload, thunkAPI) => {
  try {
    const state = thunkAPI.getState();

    const apicall = state.search.activeMode === "ACC" ? "otherAccommodationOffers" : "otherPackageOffers";

    const response = await axios.post(getHost() + "/" + apicall, {
      ...populateOfferPost(
        payload.fromDate,
        payload.untilDate,
        payload.station,
        state.search.destinationStations.length > 0 ? state.search.destinationStations : [],
        payload.searchOptions,
        payload.selectedDestination,
        payload.touroperator,
        payload.inboundtime,
        payload.outboundtime,
      ),
      mode: state.system.mode,
      withActions: payload.withActions === false ? false : true,
      couponcode: state.search.couponcode,
      offer: payload.offer?.origOffer,
      promosession: state.system.sessionId,
    });
    if (response.data.Offers.OfferCount > 0) {
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return addValuesToOffer(e, state);
      });
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return !e.OfferServices.Package
          ? {
              ...e,
              OfferServices: {
                Package: { Accommodation: e.OfferServices.Accommodation },
              },
            }
          : e;
      });
      for (let i = 0; i < response.data.Offers.Offer.length; i++) {
        let offer = response.data.Offers.Offer[i];

        offer.betterOffer = true;
      }
    }

    if (Array.isArray(response.data.Offers.Offer)) {
      if (state.search.durationkind && state.search.durationkind.value === "Stay") {
        let dur = state.search.duration.value;

        if (dur === "0.1") {
          let differenceInTime = new Date(state.search.travelDate.to.split('"').join("")).getTime() - new Date(state.search.travelDate.from.split('"').join("")).getTime();

          dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
          if (state.search.durationkind.value === "Stay") dur = Math.floor(differenceInTime / (1000 * 3600 * 24)) + "";
        }
        if ((dur + "").indexOf("-") > -1) {
          let durmin = dur.split("-")[0] * 1;
          let durmax = dur.split("-")[1] * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays >= durmin && e.TravelDateInfo.OvernightStays <= durmax);
        } else {
          dur = dur * 1;
          response.data.Offers.Offer = response.data.Offers.Offer.filter((e) => e.TravelDateInfo && e.TravelDateInfo.OvernightStays === dur);
        }
      }

      //response.data.Offers.OfferCount = response.data.Offers.Offer.length;
    }

    thunkAPI.dispatch(
      addOffers({
        offers: Array.isArray(response.data.Offers.Offer) ? response.data.Offers.Offer : [],
        payload: { ...payload, thunk: "searchBetterOffers" },
        meta: (({ Offer, ...rest }) => rest)(response.data.Offers),
      }),
    );
    thunkAPI.dispatch(
      addClassicOffers({
        offers: Array.isArray(response.data.Offers.Offer) ? response.data.Offers.Offer : [],
        payload: { ...payload, thunk: "searchBetterOffers" },
        meta: (({ Offer, ...rest }) => rest)(response.data.Offers),
      }),
    );
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

/*export const searchAlternativeFlights = createAsyncThunk(
  "hotel/searchAlternativeFlights",
  async (payload, thunkAPI) => {
    try {
      const response = await axios.get(
        getHost() + "/alternativeFlights?SessionID=" + payload.SessionID
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);*/

export const checkHotelActions = createAsyncThunk("hotel/checkHotelActions", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/checkActions", {
      promosession: state.system.sessionId,
      offer: payload.offer,
      queryid: state.offers.offerqueryid,
      agencypictures: payload.agencypictures,
    });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const checkHotelActionsLowestPrice = createAsyncThunk("hotel/checkHotelActionsLowestPrice", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/checkActions", {
      promosession: state.system.sessionId,
      offer: payload.offer,
      queryid: state.offers.offerqueryid,
      agencypictures: payload.agencypictures,
    });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const checkHotelActionsBestValue = createAsyncThunk("hotel/checkHotelActionsBestValue", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/checkActions", {
      promosession: state.system.sessionId,
      offer: payload.offer,
      queryid: state.offers.offerqueryid,
      agencypictures: payload.agencypictures,
    });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const checkHotelActionsPremium = createAsyncThunk("hotel/checkHotelActionsPremium", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/checkActions", {
      promosession: state.system.sessionId,
      offer: payload.offer,
      queryid: state.offers.offerqueryid,
      agencypictures: payload.agencypictures,
    });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const availabilityAndPriceCheck = createAsyncThunk("hotel/availabilityAndPriceCheck", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/availabilityAndPriceCheck", {
      offer: payload.offer?.origOffer,
      source: payload.offer?.source,
      OfferID: payload.OfferID,
      flight: state.search.activeMode == "PAC" ? "1" : "0",
      adults: state.search.adults.value,
      children: state.search.children.value,
      childrenages: state.search.childrenages.map((e) => e.value).toString(),
      multiroomdivider: state.search.multiroomdivider,
      roomallocation: heteroRoomAllocationParam(state.search.roomallocation),
    });

    return response.data;
  } catch (error) {
    console.error(error);

    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const availabilityAndPriceCheckLowestPrice = createAsyncThunk("hotel/availabilityAndPriceCheckLowestPrice", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/availabilityAndPriceCheck", {
      offer: payload.offer?.origOffer,
      source: payload.offer?.source,
      OfferID: payload.OfferID,
      flight: state.search.activeMode == "PAC" ? "1" : "0",
      adults: state.search.adults.value,
      children: state.search.children.value,
      childrenages: state.search.childrenages.map((e) => e.value).toString(),
      multiroomdivider: state.search.multiroomdivider,
      roomallocation: heteroRoomAllocationParam(state.search.roomallocation),
    });

    return response.data;
  } catch (error) {
    console.error(error);

    return thunkAPI.rejectWithValue({ error: error.message });
  }
}, { condition: allowsAutoAvailabilityCheck });

export const availabilityAndPriceCheckBestValue = createAsyncThunk("hotel/availabilityAndPriceCheckBestValue", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/availabilityAndPriceCheck", {
      offer: payload.offer?.origOffer,
      source: payload.offer?.source,
      OfferID: payload.OfferID,
      flight: state.search.activeMode == "PAC" ? "1" : "0",
      adults: state.search.adults.value,
      children: state.search.children.value,
      childrenages: state.search.childrenages.map((e) => e.value).toString(),
      multiroomdivider: state.search.multiroomdivider,
      roomallocation: heteroRoomAllocationParam(state.search.roomallocation),
    });

    return response.data;
  } catch (error) {
    console.error(error);

    return thunkAPI.rejectWithValue({ error: error.message });
  }
}, { condition: allowsAutoAvailabilityCheck });

export const availabilityAndPriceCheckPremium = createAsyncThunk("hotel/availabilityAndPriceCheckPremiun", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/availabilityAndPriceCheck", {
      offer: payload.offer?.origOffer,
      source: payload.offer?.source,
      OfferID: payload.OfferID,
      flight: state.search.activeMode == "PAC" ? "1" : "0",
      adults: state.search.adults.value,
      children: state.search.children.value,
      childrenages: state.search.childrenages.map((e) => e.value).toString(),
      multiroomdivider: state.search.multiroomdivider,
      roomallocation: heteroRoomAllocationParam(state.search.roomallocation),
    });

    return response.data;
  } catch (error) {
    console.error(error);

    return thunkAPI.rejectWithValue({ error: error.message });
  }
}, { condition: allowsAutoAvailabilityCheck });

export const availabilityAndPriceCheckCalendar = createAsyncThunk("hotel/availabilityAndPriceCheckCalendar", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();

  try {
    const response = await axios.post(getHost() + "/availabilityAndPriceCheck", {
      offer: payload.offer?.origOffer,
      source: payload.offer?.source,
      OfferID: payload.OfferID,
      flight: state.search.activeMode == "PAC" ? "1" : "0",
      adults: state.search.adults.value,
      children: state.search.children.value,
      childrenages: state.search.childrenages.map((e) => e.value).toString(),
      multiroomdivider: state.search.multiroomdivider,
      roomallocation: heteroRoomAllocationParam(state.search.roomallocation),
    });

    return response.data;
  } catch (error) {
    console.error(error);

    return thunkAPI.rejectWithValue({ error: error.message });
  }
}, { condition: allowsAutoAvailabilityCheck });

export const getCatalogData = createAsyncThunk("hotel/getCatalogData", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();
  //console.log();
  try {
    const response = await axios.get(getHost() + "/giatamedia/" + encodeURIComponent(state.hotel.selectedHotel.HotelCodes.HotelGiataID));
    if (Array.isArray(response.data.result.data)) {
      for (let i = 0; i < response.data.result.data.length; i++)
        if (response.data.result.data && Array.isArray(response.data.result.data[i].Bildfile)) {
          for (let j = 0; j < response.data.result.data[i].Bildfile.length; j++) {
            //              console.log(response.data.result.data[i].Bildfile[j]);
            response.data.result.data[i].Bildfile[j]._ =
              getHost() + "/giataimage?size=" + response.data.result.data[i].Bildfile[j].$.size + "&image=" + encodeURIComponent(response.data.result.data[i].Bildfile[j]._);
          }
        }
    }
    return response.data.result.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const checkOfferAction = createAsyncThunk("hotel/checkOfferAction", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();
  try {
    const response = await axios.post(getHost() + "/checkofferaction", {
      offerid: payload.offerId,
      sessionid: state.system.sessionId,
      agencyid: window.configData.AGENCYID,
      hotel: state.hotel.selectedHotel,
      typ: state.search?.activeMode == "PAC" ? "package" : "accommodation",
      offer: { ...payload.offer, bookinginfo: {} },
      bookinginfo: payload.offer.bookinginfo,
      couponcode: state.search.couponcode,
    });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

export const searchAlternativeTransports = createAsyncThunk("hotel/alternativeTransportForPackageOffer", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();
  //console.log("alteranet", payload);
  try {
    const response = await axios.post(getHost() + "/alternativeTransportForPackageOffer", {
      ...populateAlternativeFlightsPost(
        payload.offer,
        {
          adults: state.search.adults,
          children: state.search.children,
          childrenages: state.search.childrenages,
        },
        state.search.stations,
        state.search.destinationStations.length > 0 ? state.search.destinationStations : state.filter.destinationAirports,
        state.search.durationkind,
        state.search.outboundtime,
        state.search.inboundtime,
        state.search.operatingbrand,
        payload.offset ? payload.offset : 0,
        state.search.multiroomdivider,
        state.search.roomallocation,
      ),
      hotelcode: state.hotel.selectedHotel.HotelID,
      amount: 10,
      offset: payload.offset,
      couponcode: state.search.couponcode,
      mode: state.system.mode,
      withActions: payload.withActions === false ? false : true,
      offer: payload.offer?.origOffer || payload.offer,
      source: payload.offer?.source,
    });

    if (response.data.Offers.OfferCount > 0) {
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return addValuesToOffer(e, state);
      });
    }

    if (response.data.Offers.OfferCount > 0) {
      response.data.Offers.Offer = response.data.Offers.Offer.map((e) => {
        return { ...e, alternativeflight: true };
      });
    }

    thunkAPI.dispatch(
      addOffers({
        offers: Array.isArray(response.data.Offers.Offer) ? response.data.Offers.Offer : [],
        payload: {
          ...payload,
          parentid: payload.offer.OfferID,
          thunk: "searchAlternativeTransports",
        },

        meta: (({ Offer, ...rest }) => rest)(response.data.Offers),
      }),
    );
    thunkAPI.dispatch(
      addClassicOffers({
        offers: Array.isArray(response.data.Offers.Offer) ? response.data.Offers.Offer : [],
        payload: {
          ...payload,
          parentid: payload.offer.OfferID,
          thunk: "searchAlternativeTransports",
        },
        meta: (({ Offer, ...rest }) => rest)(response.data.Offers),
      }),
    );
    //console.log("rddnb", response.data);
    return response.data;
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue({ error: error.message });
  }
});

// Server-Request-Groesse pro Seite; die Thunk-Schleife holt alle Seiten durch.
const ALL_ALTERNATIVE_FLIGHTS_FETCH_PAGE = 100;
// Bis zu so vielen Fluegen zeigt die Alle-Fluege-Ansicht die Liste direkt,
// ohne die Hin-/Rueckflug-Dropdowns.
export const ALL_ALTERNATIVE_FLIGHTS_DISPLAY_LIMIT = 10;

export const fetchAllAlternativeFlights = createAsyncThunk("hotel/fetchAllAlternativeFlights", async (payload, thunkAPI) => {
  const state = thunkAPI.getState();
  const tourOperatorCode = payload.offer.TourOperator.TourOperatorCode;

  try {
    let collected = [];
    let seen = new Set();
    let hotelDictionary = null;
    let geoDictionary = null;
    let offset = 0;
    let guard = 0;
    let more = true;

    while (more && guard < 25) {
      guard = guard + 1;

      const response = await axios.post(getHost() + "/alternativeTransportForPackageOffer", {
        ...populateAlternativeFlightsPost(
          payload.offer,
          {
            adults: state.search.adults,
            children: state.search.children,
            childrenages: state.search.childrenages,
          },
          state.search.stations,
          state.search.destinationStations.length > 0 ? state.search.destinationStations : state.filter.destinationAirports,
          state.search.durationkind,
          state.search.outboundtime,
          state.search.inboundtime,
          state.search.operatingbrand,
          offset,
          state.search.multiroomdivider,
          state.search.roomallocation,
        ),
        hotelcode: state.hotel.selectedHotel.HotelID,
        amount: ALL_ALTERNATIVE_FLIGHTS_FETCH_PAGE,
        offset: offset,
        couponcode: state.search.couponcode,
        mode: state.system.mode,
        withActions: false,
        offer: payload.offer?.origOffer || payload.offer,
        source: payload.offer?.source,
      });

      const data = response.data;
      const pageOffers = Array.isArray(data?.Offers?.Offer) ? data.Offers.Offer : [];

      if (!hotelDictionary && data?.HotelDictionary) hotelDictionary = data.HotelDictionary;
      if (!geoDictionary && data?.GeoDictionary) geoDictionary = data.GeoDictionary;

      let added = 0;
      for (let i = 0; i < pageOffers.length; i++) {
        const enriched = { ...addValuesToOffer(pageOffers[i], state), alternativeflight: true };
        if (seen.has(enriched.OfferID)) continue;
        seen.add(enriched.OfferID);
        collected.push(enriched);
        added = added + 1;
      }

      offset = offset + pageOffers.length;
      more = Boolean(data?.Offers?.MoreOffersAvailable) && added > 0 && pageOffers.length > 0;
      if (collected.length > 1500) more = false;
    }

    const filtered = collected.filter((suboffer) => suboffer.OfferID !== payload.offer.OfferID);

    return {
      tourOperatorCode,
      Offers: { Offer: filtered, OfferCount: filtered.length },
      HotelDictionary: hotelDictionary,
      GeoDictionary: geoDictionary,
    };
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue({ error: error.message, tourOperatorCode });
  }
});

const initialState = {
  offers: {},
  checkids: [],
  hotelOffersFound: true,
  alternativeids: [],
  otherids: [],
  selectedHotel: {},
  hotelOfferInfos: {},
  departureDates: {},
  durationVariants: [],
  durationInfo: [],
  durationVariantsRequestId: null,
  durationInfoRequestId: null,
  catalogData: [],
  offerId: "",
  hotelData: {},
  infoHotel: {},
  alternativeTransports: {},
  allAlternativeFlights: {},
  allAlternativeFlightsLoading: [],
  hotelSpecialAmount: [],
  hotelSpecialRoomTypes: [],
  subload: false,
  betterOffers: {},
  hotelPage: 1,
  hotelSort: hotelSortOptions[0],
  cityInfo: [],
  doAvailabilityCheck: false,
  doAvailabilityCheckBestValue: false,
  doAvailabilityCheckPremium: false,
  doCalendarCheck: false,
  bestPriceOffer: {},
  recommendedOffer: {},
  lowestPriceOfferInfos: {},
  bestValueOfferInfos: {},
  premiumOfferInfos: {},
};

export const hotelSlice = createSlice({
  name: "hotel",
  initialState,
  reducers: {
    changeTourOperatorOffer: (state, action) => {
      let infos = { ...state.hotelOfferInfos };

      // Genau die angeklickte Karte ersetzen (payload: { offer, replaceOfferId }). Frueher ging das
      // ueber den Veranstalter-Code - die Liste enthaelt aber Peakwork- und Amadeus-Angebote
      // desselben Veranstalters, ein Wechsel ueberschrieb dann auch fremde Karten (Ticket 26000162).
      const { offer, replaceOfferId } = action.payload;
      infos.Offers.Offer = infos.Offers.Offer.map((o) => (o.OfferID == replaceOfferId ? offer : o));
      state.hotelOfferInfos = { ...infos, init: 0 };
    },

    clearAllAlternativeFlights: (state, action) => {
      if (action.payload) {
        const next = { ...state.allAlternativeFlights };
        delete next[action.payload];
        state.allAlternativeFlights = next;
        state.allAlternativeFlightsLoading = state.allAlternativeFlightsLoading.filter((e) => e !== action.payload);
      } else {
        state.allAlternativeFlights = {};
        state.allAlternativeFlightsLoading = [];
      }
    },

    setBestPriceOffer: (state, action) => {
      state.bestPriceOffer = action.payload;
    },

    setRecommendedOffer: (state, action) => {
      state.recommendedOffer = action.payload;
    },

    setHotelOffersFound: (state, action) => {
      state.infoHotel = action.payload;
    },
    setDoAvailabilityCheck: (state, action) => {
      state.doAvailabilityCheck = action.payload;
    },
    setDoCalendarCheck: (state, action) => {
      state.doCalendarCheck = action.payload;
    },
    setDoAvailabilityCheckBestValue: (state, action) => {
      state.doAvailabilityCheckBestValue = action.payload;
    },
    setDoAvailabilityCheckPremium: (state, action) => {
      state.doAvailabilityCheckPremium = action.payload;
    },
    setInfoHotel: (state, action) => {
      state.infoHotel = action.payload;
    },
    setSelectedHotel: (state, action) => {
      state.selectedHotel = action.payload;
    },
    setHotelData: (state, action) => {
      state.hotelData = action.payload;
    },
    setHotelOfferInfos: (state, action) => {
      state.hotelOfferInfos = action.payload;
    },
    setHotelPage: (state, action) => {
      state.hotelPage = action.payload;
    },
    setHotelSort: (state, action) => {
      state.hotelSort = action.payload;
    },
    setOfferId: (state, action) => {
      state.offerId = action.payload;
    },
    setHotelSpecialRoomTypes: (state, action) => {
      state.hotelSpecialRoomTypes = action.payload;
    },

    clearMarketingActions: (state, action) => {
      let infos = { ...state.hotelOfferInfos };
      //console.log(action.payload);
      for (let i = 0; i < infos.Offers.Offer.length; i++) {
        if (infos.Offers.Offer[i].OfferID === action.payload) {
          if (Array.isArray(infos.Offers.Offer[i].MarketingActions) && infos.Offers.Offer[i].MarketingActions.length > 0) {
            infos.Offers.Offer[i].MarketingActions = [infos.Offers.Offer[i].MarketingActions[0]];
            infos.Offers.Offer[i].MarketingActions[0].MarketingProperties = [];
          }
        }
      }

      state.hotelOfferInfos = { ...infos, init: 0 };
    },

    setOfferFlexbooked: (state, action) => {
      let infos = { ...state.hotelOfferInfos };
      //console.log(infos);
      for (let i = 0; i < infos.Offers.Offer.length; i++) {
        //console.log(infos.Offers.Offer[i]);
        if (infos.Offers.Offer[i].OfferID === action.payload.offerId) {
          infos.Offers.Offer[i].flexbooked = action.payload.flexbooked;
        }
      }

      state.hotelOfferInfos = { ...infos, init: 0 };
    },
    setMarked: (state, action) => {
      let infos = { ...state.hotelOfferInfos };
      //console.log(infos);
      for (let i = 0; i < infos.Offers.Offer.length; i++) {
        //console.log(infos.Offers.Offer[i]);
        if (infos.Offers.Offer[i].OfferID === action.payload.offerId) {
          //console.log(infos.Offers.Offer[i].OfferID);
          if (Array.isArray(infos.Offers.Offer[i].MarketingActions) && infos.Offers.Offer[i].MarketingActions.length > 0) {
            infos.Offers.Offer[i].MarketingActions[0].marked = action.payload.marked;
          } else {
            infos.Offers.Offer[i].MarketingActions = [
              {
                marked: action.payload.marked,
              },
            ];
          }
        }
      }

      state.hotelOfferInfos = { ...infos, init: 0 };
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getCityInfo.pending, (state) => {
      state.cityInfo = [];
    });
    builder.addCase(getCityInfo.fulfilled, (state, { payload }) => {
      state.cityInfo = payload;
    });
    builder.addCase(getCityInfo.rejected, (state) => {
      state.cityInfo = [];
    });

    builder.addCase(checkHotelActionsLowestPrice.fulfilled, (state, { payload, meta }) => {
      if (meta.arg.offer.OfferID && Array.isArray(state.lowestPriceOfferInfos?.Offers?.Offer)) {
        let infos = { ...state.lowestPriceOfferInfos };

        if (!Array.isArray(infos?.Offers?.Offer)) {
          infos.Offers = {};
          infos.Offers.Offer = [];
        }

        infos.Offers.Offer = infos.Offers.Offer.map((o) => (o.OfferID == meta.arg.offer.OfferID ? { ...o, promo: payload.data } : o));

        state.lowestPriceOfferInfos = { ...infos, init: 0 };
      }
    });

    builder.addCase(checkHotelActionsBestValue.fulfilled, (state, { payload, meta }) => {
      if (meta.arg.offer.OfferID && Array.isArray(state.bestValueOfferInfos?.Offers?.Offer)) {
        let infos = { ...state.bestValueOfferInfos };

        if (!Array.isArray(infos?.Offers?.Offer)) {
          infos.Offers = {};
          infos.Offers.Offer = [];
        }

        infos.Offers.Offer = infos.Offers.Offer.map((o) => (o.OfferID == meta.arg.offer.OfferID ? { ...o, promo: payload.data } : o));

        state.bestValueOfferInfos = { ...infos, init: 0 };
      }
    });

    builder.addCase(checkHotelActionsPremium.fulfilled, (state, { payload, meta }) => {
      if (meta.arg.offer.OfferID && Array.isArray(state.premiumOfferInfos?.Offers?.Offer)) {
        let infos = { ...state.premiumOfferInfos };

        if (!Array.isArray(infos?.Offers?.Offer)) {
          infos.Offers = {};
          infos.Offers.Offer = [];
        }

        infos.Offers.Offer = infos.Offers.Offer.map((o) => (o.OfferID == meta.arg.offer.OfferID ? { ...o, promo: payload.data } : o));

        state.premiumOfferInfos = { ...infos, init: 0 };
      }
    });

    builder.addCase(checkHotelActions.fulfilled, (state, { payload, meta }) => {
      if (meta.arg.offer.OfferID && Array.isArray(state.hotelOfferInfos?.Offers?.Offer)) {
        let infos = { ...state.hotelOfferInfos };

        if (meta.arg.parentid) {
          if (meta.arg.alternativeFlight) {
            infos = { ...state.alternativeTransports[meta.arg.parentid] };
          } else {
            infos = { ...state.betterOffers[meta.arg.parentid] };
          }
        }

        if (!Array.isArray(infos?.Offers?.Offer)) {
          infos.Offers = {};
          infos.Offers.Offer = [];
        }

        infos.Offers.Offer = infos.Offers.Offer.map((o) => (o.OfferID == meta.arg.offer.OfferID ? { ...o, promo: payload.data } : o));

        if (meta.arg.parentid) {
          if (meta.arg.alternativeFlight) {
            state.alternativeTransports = {
              ...state.alternativeTransports,
              [meta.arg.parentid]: infos,
            };
          } else {
            state.betterOffers = {
              ...state.betterOffers,
              [meta.arg.parentid]: infos,
            };
          }
        } else state.hotelOfferInfos = { ...infos, init: 0 };
      }
    });
    builder.addCase(getRegionInfo.pending, (state) => {
      state.cityInfo = [];
    });
    builder.addCase(getRegionInfo.fulfilled, (state, { payload }) => {
      state.cityInfo = payload;
    });
    builder.addCase(getRegionInfo.rejected, (state) => {
      state.cityInfo = [];
    });
    builder.addCase(getCatalogData.pending, (state) => {
      state.catalogData = [];
    });
    builder.addCase(getCatalogData.fulfilled, (state, { payload }) => {
      state.catalogData = payload;
    });
    builder.addCase(getCatalogData.rejected, (state) => {
      state.catalogData = [];
    });

    builder.addCase(checkOfferAction.fulfilled, (state, action) => {
      let infos = { ...state.hotelOfferInfos };
      let offers = [];

      if (Array.isArray(infos?.Offers?.Offer)) {
        for (let i = 0; i < infos.Offers.Offer.length; i++) {
          let off = infos.Offers.Offer[i];

          let dat = action.payload.data.find((e) => e.OfferID === off.OfferID);
          if (!dat) {
            offers.push(off);
            continue;
          }

          try {
            let ma = off.MarketingActions;

            if (!Array.isArray(ma) && dat) {
              off.MarketingActions = [{ ...dat }];
              if (Array.isArray(off?.MarketingActions[0]?.MarketingProperties) && off.MarketingActions[0].MarketingProperties.length > 0)
                off.MarketingActions[0].MarketingProperties = off.MarketingActions[0].MarketingProperties[0];

              ma = off.MarketingActions;
            }

            if (Array.isArray(ma) && ma.length === 0 && dat) {
              off.MarketingActions = [{ ...dat }];
              if (Array.isArray(off?.MarketingActions[0]?.MarketingProperties) && off.MarketingActions[0].MarketingProperties.length > 0)
                off.MarketingActions[0].MarketingProperties = off.MarketingActions[0].MarketingProperties[0];

              ma = off.MarketingActions;
            }

            if (Array.isArray(ma) && ma.length > 1) {
              ma = [ma[0]];
            }

            if (Array.isArray(ma) && ma.length === 1) {
              ma[0].MarketingProperties = {};
            }

            if (Array.isArray(ma) && ma.length === 1 && Array.isArray(dat.MarketingProperties) && dat.MarketingProperties.length > 0) {
              let nma = [];
              for (let j = 0; j < dat.MarketingProperties.length; j++) {
                nma.push({
                  ...ma[0],
                  typ_id: dat.MarketingProperties[j].typ_id,
                  onpage: dat.MarketingProperties[j].onpage,

                  MarketingProperties: {
                    ...dat.MarketingProperties[j],
                    offeraction: true,
                  },
                });
              }

              off.MarketingActions = nma;
            } else {
              off.MarketingActions = [
                {
                  ...ma[0],

                  MarketingProperties: {
                    offeraction: true,
                  },
                },
              ];
            }
            offers.push(off);
          } catch (e) {
            offers.push(off);
          }
        }
      }
      infos.Offers.Offer = offers;
      state.hotelOfferInfos = { ...infos, init: 0 };
    });

    builder.addCase(searchAlternativeTransports.pending, (state, action) => {
      state.alternativeids = [...state.alternativeids, action.meta.arg.offer.OfferID];
      state.alternativeTransports = {
        ...state.alternativeTransports,
        [action.meta.arg.offer.OfferID]: action.meta.arg.offset ? (action.meta.arg.offset > 0 ? { ...state.alternativeTransports[action.meta.arg.offer.OfferID] } : {}) : {},
      };
    });
    builder.addCase(searchAlternativeTransports.fulfilled, (state, action) => {
      let tmp = {
        ...state.alternativeTransports[action.meta.arg.offer.OfferID],
      };

      if (Array.isArray(tmp?.Offers?.Offer)) {
        tmp.Offers.Offer = [...tmp.Offers.Offer, ...action.payload.Offers.Offer];
        tmp.Offers.OfferCount = tmp.Offers.OfferCount + action.payload.Offers.OfferCount;
        tmp.Offers.MoreOffersAvailable = action.payload.Offers.MoreOffersAvailable;
      }
      state.alternativeTransports = {
        ...state.alternativeTransports,
        [action.meta.arg.offer.OfferID]: action.meta.arg.offset ? (action.meta.arg.offset > 0 ? { ...tmp } : action.payload) : action.payload,
      };
    });
    builder.addCase(searchAlternativeTransports.rejected, (state, action) => {
      state.alternativeids = state.alternativeids.filter((e) => e !== action.meta.arg.offer.OfferID);
      state.alternativeTransports = {
        ...state.alternativeTransports,
        [action.meta.arg.offer.OfferID]: {},
      };
    });

    builder.addCase(fetchAllAlternativeFlights.pending, (state, action) => {
      const code = action.meta.arg.offer.TourOperator.TourOperatorCode;
      state.allAlternativeFlightsLoading = [...state.allAlternativeFlightsLoading.filter((e) => e !== code), code];
    });
    builder.addCase(fetchAllAlternativeFlights.fulfilled, (state, action) => {
      const code = action.payload.tourOperatorCode;
      state.allAlternativeFlightsLoading = state.allAlternativeFlightsLoading.filter((e) => e !== code);
      state.allAlternativeFlights = { ...state.allAlternativeFlights, [code]: action.payload };
    });
    builder.addCase(fetchAllAlternativeFlights.rejected, (state, action) => {
      const code = action.payload?.tourOperatorCode || action.meta.arg.offer.TourOperator.TourOperatorCode;
      state.allAlternativeFlightsLoading = state.allAlternativeFlightsLoading.filter((e) => e !== code);
      state.allAlternativeFlights = {
        ...state.allAlternativeFlights,
        [code]: { tourOperatorCode: code, Offers: { Offer: [], OfferCount: 0 }, error: true },
      };
    });

    builder.addCase(availabilityAndPriceCheckCalendar.pending, () => {});
    builder.addCase(availabilityAndPriceCheckCalendar.fulfilled, (state, action) => {
      let d = action.payload["ns2:AvailabilityAndPriceCheckRS"];

      try {
        if (d?.Offer) {
          if (d.Offer?.Cautions?.Caution) {
          }
        }
      } catch (e) {
        console.error(e);
      }

      let tmp = { ...state.departureDates };

      //console.log(Array.isArray(tmp?.Offers?.Offer),d.Offer);
      if (Array.isArray(tmp?.Offers?.Offer) && d.Offer) {
        let tmpArray = tmp.Offers.Offer.map((element) => {
          return element.OfferID === action.meta.arg.OfferID
            ? { ...element, bookinginfo: d, OfferProperties: { ...element.OfferProperties, ...d.Offer?.OfferProperties } }
            : element;
        });
        tmp.Offers.Offer = tmpArray;
      } else {
        if (Array.isArray(tmp?.Offers?.Offer)) {
          let tmpArray = tmp.Offers.Offer.map((element) => {
            return element.OfferID === action.meta.arg.OfferID
              ? { ...element, bookinginfo: d, OfferProperties: { ...element.OfferProperties, ...d.Offer?.OfferProperties } }
              : element;
          });
          tmp.Offers.Offer = tmpArray;
        }
      }

      state.departureDates = { ...tmp, init: 0 };
    });
    builder.addCase(availabilityAndPriceCheckCalendar.rejected, () => {});

    builder.addCase(availabilityAndPriceCheckLowestPrice.pending, () => {});
    builder.addCase(availabilityAndPriceCheckLowestPrice.fulfilled, (state, action) => {
      let d = action.payload["ns2:AvailabilityAndPriceCheckRS"];

      try {
        if (d?.Offer) {
          if (d.Offer?.Cautions?.Caution) {
          }
        }
      } catch (e) {
        console.error(e);
      }

      let tmp = { ...state.lowestPriceOfferInfos };

      //console.log(Array.isArray(tmp?.Offers?.Offer),d.Offer);
      if (Array.isArray(tmp?.Offers?.Offer) && d.Offer) {
        let tmpArray = tmp.Offers.Offer.map((element) => {
          return element.OfferID === action.meta.arg.OfferID
            ? { ...element, bookinginfo: d, OfferProperties: { ...element.OfferProperties, ...d.Offer?.OfferProperties } }
            : element;
        });
        tmp.Offers.Offer = tmpArray;
      } else {
        if (Array.isArray(tmp?.Offers?.Offer)) {
          let tmpArray = tmp.Offers.Offer.map((element) => {
            return element.OfferID === action.meta.arg.OfferID
              ? { ...element, bookinginfo: d, OfferProperties: { ...element.OfferProperties, ...d.Offer?.OfferProperties } }
              : element;
          });
          tmp.Offers.Offer = tmpArray;
        }
      }

      state.lowestPriceOfferInfos = { ...tmp, init: 0 };
    });
    builder.addCase(availabilityAndPriceCheckLowestPrice.rejected, (state, action) => {
      const unavailable = { "ns2:AvailabilityAndPriceCheckRS": { Status: { StatusNo: "9999", StatusText: "timeout" } } };
      let tmp = { ...state.lowestPriceOfferInfos };
      if (Array.isArray(tmp?.Offers?.Offer)) {
        tmp.Offers.Offer = tmp.Offers.Offer.map((e) => e.OfferID === action.meta.arg.OfferID ? { ...e, bookinginfo: unavailable } : e);
        state.lowestPriceOfferInfos = { ...tmp, init: 0 };
      }
    });

    builder.addCase(availabilityAndPriceCheckBestValue.pending, () => {});
    builder.addCase(availabilityAndPriceCheckBestValue.fulfilled, (state, action) => {
      let d = action.payload["ns2:AvailabilityAndPriceCheckRS"];

      try {
        if (d?.Offer) {
          if (d.Offer?.Cautions?.Caution) {
          }
        }
      } catch (e) {
        console.error(e);
      }

      let tmp = { ...state.bestValueOfferInfos };

      //console.log(Array.isArray(tmp?.Offers?.Offer),d.Offer);
      if (Array.isArray(tmp?.Offers?.Offer) && d.Offer) {
        let tmpArray = tmp.Offers.Offer.map((element) => {
          return element.OfferID === action.meta.arg.OfferID
            ? { ...element, bookinginfo: d, OfferProperties: { ...element.OfferProperties, ...d.Offer?.OfferProperties } }
            : element;
        });
        tmp.Offers.Offer = tmpArray;
      } else {
        if (Array.isArray(tmp?.Offers?.Offer)) {
          let tmpArray = tmp.Offers.Offer.map((element) => {
            return element.OfferID === action.meta.arg.OfferID
              ? { ...element, bookinginfo: d, OfferProperties: { ...element.OfferProperties, ...d.Offer?.OfferProperties } }
              : element;
          });
          tmp.Offers.Offer = tmpArray;
        }
      }

      state.bestValueOfferInfos = { ...tmp, init: 0 };
    });
    builder.addCase(availabilityAndPriceCheckBestValue.rejected, (state, action) => {
      const unavailable = { "ns2:AvailabilityAndPriceCheckRS": { Status: { StatusNo: "9999", StatusText: "timeout" } } };
      let tmp = { ...state.bestValueOfferInfos };
      if (Array.isArray(tmp?.Offers?.Offer)) {
        tmp.Offers.Offer = tmp.Offers.Offer.map((e) => e.OfferID === action.meta.arg.OfferID ? { ...e, bookinginfo: unavailable } : e);
        state.bestValueOfferInfos = { ...tmp, init: 0 };
      }
    });

    builder.addCase(availabilityAndPriceCheckPremium.pending, () => {});
    builder.addCase(availabilityAndPriceCheckPremium.fulfilled, (state, action) => {
      let d = action.payload["ns2:AvailabilityAndPriceCheckRS"];

      try {
        if (d?.Offer) {
          if (d.Offer?.Cautions?.Caution) {
          }
        }
      } catch (e) {
        console.error(e);
      }

      let tmp = { ...state.premiumOfferInfos };

      //console.log(Array.isArray(tmp?.Offers?.Offer),d.Offer);
      if (Array.isArray(tmp?.Offers?.Offer) && d.Offer) {
        let tmpArray = tmp.Offers.Offer.map((element) => {
          return element.OfferID === action.meta.arg.OfferID
            ? { ...element, bookinginfo: d, OfferProperties: { ...element.OfferProperties, ...d.Offer?.OfferProperties } }
            : element;
        });
        tmp.Offers.Offer = tmpArray;
      } else {
        if (Array.isArray(tmp?.Offers?.Offer)) {
          let tmpArray = tmp.Offers.Offer.map((element) => {
            return element.OfferID === action.meta.arg.OfferID
              ? { ...element, bookinginfo: d, OfferProperties: { ...element.OfferProperties, ...d.Offer?.OfferProperties } }
              : element;
          });
          tmp.Offers.Offer = tmpArray;
        }
      }

      state.premiumOfferInfos = { ...tmp, init: 0 };
    });
    builder.addCase(availabilityAndPriceCheckPremium.rejected, (state, action) => {
      const unavailable = { "ns2:AvailabilityAndPriceCheckRS": { Status: { StatusNo: "9999", StatusText: "timeout" } } };
      let tmp = { ...state.premiumOfferInfos };
      if (Array.isArray(tmp?.Offers?.Offer)) {
        tmp.Offers.Offer = tmp.Offers.Offer.map((e) => e.OfferID === action.meta.arg.OfferID ? { ...e, bookinginfo: unavailable } : e);
        state.premiumOfferInfos = { ...tmp, init: 0 };
      }
    });

    builder.addCase(availabilityAndPriceCheck.pending, (state, action) => {
      state.checkids = [...state.checkids, action.meta.arg.OfferID ? action.meta.arg.OfferID : action.meta.arg.FlightID];
    });
    builder.addCase(availabilityAndPriceCheck.fulfilled, (state, action) => {
      //console.log(action.meta.arg);
      state.checkids = state.checkids.filter((e) => e !== (action.meta.arg.OfferID ? action.meta.arg.OfferID : action.meta.arg.FlightID));
      let d = action.payload["ns2:AvailabilityAndPriceCheckRS"];

      if (!d) {
        const unavailable = { "ns2:AvailabilityAndPriceCheckRS": { Status: { StatusNo: "9999", StatusText: "error" } } };
        let tmp = {};
        if (action.meta.arg.FlightID || action.meta.arg.alternativeFlight) {
          tmp = { ...state.alternativeTransports[action.meta.arg.parentid] };
        } else {
          if (action.meta.arg.parentid) tmp = { ...state.betterOffers[action.meta.arg.parentid] };
          else tmp = { ...state.hotelOfferInfos };
        }
        if (Array.isArray(tmp?.Offers?.Offer)) {
          tmp.Offers.Offer = tmp.Offers.Offer.map((element) =>
            element.OfferID === action.meta.arg.OfferID ? { ...element, bookinginfo: unavailable } : element,
          );
        }
        if (action.meta.arg.FlightID || action.meta.arg.alternativeFlight) {
          state.alternativeTransports = { ...state.alternativeTransports, [action.meta.arg.parentid]: tmp };
        } else {
          if (action.meta.arg.parentid) {
            state.betterOffers = { ...state.betterOffers, [action.meta.arg.parentid]: tmp };
          } else {
            state.hotelOfferInfos = { ...tmp, init: 0 };
          }
        }
        return;
      }

      try {
        if (d?.Offer) {
          if (d.Offer?.Cautions?.Caution) {
            /*axios.post(getHost() + "/sethotelproperties", {
              HotelGiataID: action.meta.arg.HotelGiataID,
              keyproperty: "cautions",
              properties: {
                ["date" + new Date().getTime()]: {
                  TourOperator: d.Offer.TourOperator.Code,
                  cautions: d.Offer.Cautions.Caution,
                },
              },
            });*/
          }
        }
      } catch (e) {
        console.error(e);
      }

      let tmp = {};
      if (action.meta.arg.FlightID || action.meta.arg.alternativeFlight) {
        tmp = { ...state.alternativeTransports[action.meta.arg.parentid] };
      } else {
        if (action.meta.arg.parentid) tmp = { ...state.betterOffers[action.meta.arg.parentid] };
        else tmp = { ...state.hotelOfferInfos };
      }
      //console.log(Array.isArray(tmp?.Offers?.Offer),d.Offer);
      if (Array.isArray(tmp?.Offers?.Offer) && d.Offer) {
        let tmpArray = tmp.Offers.Offer.map((element) => {
          return element.OfferID === action.meta.arg.OfferID
            ? { ...element, bookinginfo: d, OfferProperties: { ...element.OfferProperties, ...d.Offer?.OfferProperties } }
            : element;
        });
        tmp.Offers.Offer = tmpArray;
      } else {
        if (Array.isArray(tmp?.Offers?.Offer)) {
          let tmpArray = tmp.Offers.Offer.map((element) => {
            return element.OfferID === action.meta.arg.OfferID
              ? { ...element, bookinginfo: d, OfferProperties: { ...element.OfferProperties, ...d.Offer?.OfferProperties } }
              : element;
          });
          tmp.Offers.Offer = tmpArray;
        }
      }

      if (action.meta.arg.FlightID || action.meta.arg.alternativeFlight) {
        state.alternativeTransports = {
          ...state.alternativeTransports,
          [action.meta.arg.parentid]: tmp,
        };
      } else {
        if (action.meta.arg.parentid) {
          //console.log(1);
          state.betterOffers = {
            ...state.betterOffers,
            [action.meta.arg.parentid]: tmp,
          };
        } else state.hotelOfferInfos = { ...tmp, init: 0 };
      }
    });
    builder.addCase(availabilityAndPriceCheck.rejected, (state, action) => {
      state.checkids = state.checkids.filter((e) => e !== (action.meta.arg.OfferID ? action.meta.arg.OfferID : action.meta.arg.FlightID));

      const unavailable = {
        "ns2:AvailabilityAndPriceCheckRS": {
          Status: { StatusNo: "9999", StatusText: "timeout" },
        },
      };

      let tmp = {};
      if (action.meta.arg.FlightID || action.meta.arg.alternativeFlight) {
        tmp = { ...state.alternativeTransports[action.meta.arg.parentid] };
      } else {
        if (action.meta.arg.parentid) tmp = { ...state.betterOffers[action.meta.arg.parentid] };
        else tmp = { ...state.hotelOfferInfos };
      }

      if (Array.isArray(tmp?.Offers?.Offer)) {
        tmp.Offers.Offer = tmp.Offers.Offer.map((element) =>
          element.OfferID === action.meta.arg.OfferID ? { ...element, bookinginfo: unavailable } : element,
        );
      }

      if (action.meta.arg.FlightID || action.meta.arg.alternativeFlight) {
        state.alternativeTransports = { ...state.alternativeTransports, [action.meta.arg.parentid]: tmp };
      } else {
        if (action.meta.arg.parentid) {
          state.betterOffers = { ...state.betterOffers, [action.meta.arg.parentid]: tmp };
        } else {
          state.hotelOfferInfos = { ...tmp, init: 0 };
        }
      }
    });
    builder.addCase(searchDepartureDates.pending, (state) => {
      //state.hotelOfferInfos = {};
    });
    builder.addCase(searchDepartureDates.fulfilled, (state, { payload, meta }) => {
      if ((Array.isArray(payload.Offers.Offer) && payload.Offers.Offer.length > 0) || !meta.arg) state.departureDates = payload;
      else {
        state.departureDates = { ...state.departureDates };
      }
    });

    // DurationPriceBar loest searchDurationVariants/searchDurationInfo bei jeder
    // Aenderung von selectedHotelId/duration/queryid neu aus (siehe useEffect dort).
    // Wenn zwei Dispatches kurz hintereinander laufen (z.B. weil queryid/hotelId beim
    // Laden noch einmal nachzieht) und die AELTERE Anfrage SPAETER antwortet als die
    // neuere, wuerde sie sonst die schon korrekt gerenderten Daten wieder mit
    // veralteten/leeren Werten ueberschreiben ("kurz befuellt, dann weg"). Deshalb nur
    // die Antwort des zuletzt GESTARTETEN Requests uebernehmen (requestId-Tracking,
    // Standard-Pattern fuer Race Conditions bei createAsyncThunk).
    builder.addCase(searchDurationVariants.pending, (state, action) => {
      state.durationVariantsRequestId = action.meta.requestId;
    });
    builder.addCase(searchDurationVariants.fulfilled, (state, { payload, meta }) => {
      if (meta.requestId !== state.durationVariantsRequestId) return;
      state.durationVariants = Array.isArray(payload?.variants) ? payload.variants : [];
    });
    builder.addCase(searchDurationVariants.rejected, (state, { meta }) => {
      if (meta.requestId !== state.durationVariantsRequestId) return;
      state.durationVariants = [];
    });

    builder.addCase(searchDurationInfo.pending, (state, action) => {
      state.durationInfoRequestId = action.meta.requestId;
    });
    builder.addCase(searchDurationInfo.fulfilled, (state, { payload, meta }) => {
      if (meta.requestId !== state.durationInfoRequestId) return;
      state.durationInfo = Array.isArray(payload?.variants) ? payload.variants : [];
    });
    builder.addCase(searchDurationInfo.rejected, (state, { meta }) => {
      if (meta.requestId !== state.durationInfoRequestId) return;
      state.durationInfo = [];
    });

    builder.addCase(searchBestValueOffers.pending, (state) => {
      state.bestValueOfferInfos = {};
    });

    builder.addCase(searchBestValueOffers.fulfilled, (state, { payload, meta }) => {
      if (meta.arg.offset === 0) {
        if (payload.Offers.OfferCount > 0) {
          //console.log(payload);

          state.bestValueOfferInfos = { ...payload, init: meta.arg.offset === 0 ? 1 : 0 };
        } else {
          state.bestValueOfferInfos = {};
        }
      }
    });

    builder.addCase(searchBestValueOffers.rejected, (state) => {
      state.bestValueOfferInfos = {};
    });

    builder.addCase(searchPremiumOffers.pending, (state) => {
      state.premiumOfferInfos = {};
    });

    builder.addCase(searchPremiumOffers.fulfilled, (state, { payload, meta }) => {
      if (meta.arg.offset === 0) {
        if (payload.Offers.OfferCount > 0) {
          //console.log(payload);

          state.premiumOfferInfos = { ...payload, init: meta.arg.offset === 0 ? 1 : 0 };
        } else {
          state.premiumOfferInfos = {};
        }
      }
    });

    builder.addCase(searchPremiumOffers.rejected, (state) => {
      state.premiumOfferInfos = {};
    });

    builder.addCase(searchLowestPriceOffers.pending, (state) => {
      state.lowestPriceOfferInfos = {};
    });

    builder.addCase(searchLowestPriceOffers.fulfilled, (state, { payload, meta }) => {
      if (meta.arg.offset === 0) {
        if (payload.Offers.OfferCount > 0) {
          //console.log(payload);

          state.lowestPriceOfferInfos = { ...payload, init: meta.arg.offset === 0 ? 1 : 0 };
        } else {
          state.lowestPriceOfferInfos = {};
        }
      }
    });

    builder.addCase(searchLowestPriceOffers.rejected, (state) => {
      state.lowestPriceOfferInfos = {};
    });

    builder.addCase(searchHotelOffers.pending, (state, action) => {
      //state.hotelOfferInfos = {};
      //state.alternativeTransports = {};
      //state.betterOffers = {};
      if (!action.meta.arg || action.meta.arg.offset === 0) {
        state.allAlternativeFlights = {};
        state.allAlternativeFlightsLoading = [];
      }
    });
    builder.addCase(searchHotelOffers.fulfilled, (state, { payload, meta }) => {
      state.subload = false;

      if (!state?.selectedHotel?.HotelID && payload.HotelDictionary?.Hotel?.length > 0) {
        state.selectedHotel = payload.HotelDictionary.Hotel[0];
      }
      if (meta.arg.offset === 0) {
        if (payload.Offers.OfferCount > 0) {
          //console.log(payload);

          state.hotelOfferInfos = { ...payload, init: meta.arg.offset === 0 ? 1 : 0 };
        } else {
          state.hotelOfferInfos = {};

          if (!payload.Offers.MoreOffersAvailable) {
            state.hotelOffersFound = false;
          }
        }
      } else {
        if (payload.Offers.OfferCount > 0) {
          let infos = { ...state.hotelOfferInfos };
          infos.Offers.OfferCount += payload.Offers.OfferCount;
          infos.Offers.Offer = [...infos.Offers.Offer, ...payload.Offers.Offer];
          if (infos.StationDictionary?.Station) infos.StationDictionary.Station = [...infos.StationDictionary.Station, ...payload.StationDictionary.Station];

          infos.HotelDictionary.Hotel = [...infos.HotelDictionary.Hotel, ...payload.HotelDictionary.Hotel];
          infos.GeoDictionary.Cities.City = [...infos.GeoDictionary.Cities.City, ...payload.GeoDictionary.Cities.City];
          infos.GeoDictionary.Continents.Continent = [...infos.GeoDictionary.Continents.Continent, ...payload.GeoDictionary.Continents.Continent];
          infos.GeoDictionary.Countries.Country = [...infos.GeoDictionary.Countries.Country, ...payload.GeoDictionary.Countries.Country];
          infos.GeoDictionary.Provinces.Province = [...infos.GeoDictionary.Provinces.Province, ...payload.GeoDictionary.Provinces.Province];
          infos.GeoDictionary.RegionGroups.RegionGroup = [...infos.GeoDictionary.RegionGroups.RegionGroup, ...payload.GeoDictionary.RegionGroups.RegionGroup];
          infos.GeoDictionary.Regions.Region = [...infos.GeoDictionary.Regions.Region, ...payload.GeoDictionary.Regions.Region];

          state.hotelOfferInfos = { ...infos, init: meta.arg.offset === 0 ? 1 : 0 };
        }
      }
    });

    builder.addCase(searchHotelOffers.rejected, (state) => {
      state.hotelOfferInfos = {};
    });

    builder.addCase(searchBetterOffers.pending, (state, action) => {
      //state.hotelOfferInfos = {};
      state.otherids = [...state.otherids, action.meta.arg.parentid];
    });
    builder.addCase(searchBetterOffers.fulfilled, (state, action) => {
      if (action.payload.forceClear === true) state.betterOffers = {};
      if (action.payload.Offers.OfferCount > 0) {
        state.betterOffers = {
          ...state.betterOffers,
          [action.meta.arg.parentid]: action.payload,
        };
      } else {
        state.betterOffers = {
          ...state.betterOffers,
          [action.meta.arg.parentid]: {},
        };
      }

      state.otherids = state.otherids.filter((e) => e !== action.meta.arg.parentid);
    });
    builder.addCase(searchBetterOffers.rejected, (state, action) => {
      //state.hotelOfferInfos = {};
      state.otherids = state.otherids.filter((e) => e !== action.meta.arg.parentid);
    });
  },
});

// ✅ FIXED: Input selectors extract stable references, result function creates the computed object
export const selectCheckAmount = createSelector(
  (state) => state.hotel?.premiumOfferInfos?.Offers?.Offer,
  (state) => state.hotel?.bestValueOfferInfos?.Offers?.Offer,
  (state) => state.hotel?.lowestPriceOfferInfos?.Offers?.Offer,
  (premiumOffers, bestValueOffers, lowestPriceOffers) => ({
    checkAmount:
      (!Array.isArray(premiumOffers) ? 0 : premiumOffers.filter((o) => o.bookinginfo).length) +
      (!Array.isArray(bestValueOffers) ? 0 : bestValueOffers.filter((o) => o.bookinginfo).length) +
      (!Array.isArray(lowestPriceOffers) ? 0 : lowestPriceOffers.filter((o) => o.bookinginfo).length),
    checkTotal:
      (!Array.isArray(premiumOffers) ? 0 : premiumOffers.length) + (!Array.isArray(bestValueOffers) ? 0 : bestValueOffers.length) + (!Array.isArray(lowestPriceOffers) ? 0 : lowestPriceOffers.length),
  }),
);

export const {
  setSelectedHotel,
  setHotelOfferInfos,
  setHotelPage,
  setHotelSort,
  setInfoHotel,
  setOfferId,
  setHotelData,
  setMarked,
  setHotelSpecialRoomTypes,
  setOfferFlexbooked,
  clearMarketingActions,
  setHotelOffersFound,
  setDoAvailabilityCheck,
  changeTourOperatorOffer,
  clearAllAlternativeFlights,
  setBestPriceOffer,
  setRecommendedOffer,
  setDoAvailabilityCheckBestValue,
  setDoAvailabilityCheckPremium,
  setDoCalendarCheck,
} = hotelSlice.actions;

export default hotelSlice.reducer;
